export default "__VITE_ASSET__DHmiQ8b9__"